import { render, staticRenderFns } from "./JoinMemberDialog.vue?vue&type=template&id=5c8ef392&scoped=true&"
import script from "./JoinMemberDialog.vue?vue&type=script&lang=js&"
export * from "./JoinMemberDialog.vue?vue&type=script&lang=js&"
import style0 from "./JoinMemberDialog.vue?vue&type=style&index=0&id=5c8ef392&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8ef392",
  null
  
)

export default component.exports